import * as yup from 'yup';

const PAIRING_CODE_REGEX = /^\d{6}$/;

export const devicePairingSchema = yup.object({
  code: yup
    .string()
    .required()
    .test(
      'six-digit-code',
      'Enter the 6-digit code',
      (value) => !!value && PAIRING_CODE_REGEX.test(value.trim()),
    ),
});
